import React, { useState } from "react";
import styles from "./table.module.sass";
import cn from "classnames";
import Checkbox from "../../../Checkbox";
import Row from "./Row";

const Table = ({ items, access, title }) => {

  const desiredLength = 10;
  items = items.concat(Array(desiredLength - items.length).fill({})).slice(0, desiredLength)

  return (
    <div className={styles.wrapper}>
      <div className={styles.table}>
        <div className={styles.row}>
          <div className={styles.col}>Icon</div>
          <div className={styles.col}>Display Name</div>
          <div className={styles.col}>Rewards</div>
          <div className={styles.col}>Schedule</div>
          <div className={styles.col}>Current Instance</div>
          <div className={styles.col}>Status</div>
          <div className={styles.col}></div>
        </div>
        {items && items.map((x, index) => (
          <Row access={access} item={x} key={index} index={index} />))}
      </div>
    </div>
  );
};

export default Table;
